module.exports = __webpack_public_path__ + "img/nocodequestions.ba05d0e7.svg";